import { defineStore } from 'pinia';
import router from '@/router/index';
import StorageConst from '@/consts/storage.const';
import AdenLocalStorage from '@/utils/storage.util';
import {
  accountLoginRequest,
  businessList,
  getStaffId,
  userListInfo,
  userPermissions,
  verificationCodeLogin,
} from '@/api/login';
import { ChainList } from '@/api/chain';
interface ILoginState {
  token: string;
  errorText: string;
  businessData: []; // 商户数据列表,如果只有一个商户就直接进入系统，如果有多个商户数据，则让商户进行选择
  accountId: string | number;
  expireTime: number | string;
  name: string;
  barId: number | string;
  openId: string;
  permissions: [];
  gameLifeAccount: string;
  asst: string;
  userInfo: [];
}
interface ILoginAccount {
  name: string;
  password: string;
  grant_type: string;
}

export const useLoginStore = defineStore('loginStore', {
  state: (): ILoginState => ({
    token: AdenLocalStorage.get(StorageConst.STORAGE_KEY_TOKEN) ?? '',
    accountId: AdenLocalStorage.get(StorageConst.STORAGE_KEY_ACCOUNT_ID) ?? '',
    errorText: '',
    businessData: AdenLocalStorage.get(StorageConst.STORAGE_KEY_BUSINESS_LIST) ?? [],
    expireTime: AdenLocalStorage.get(StorageConst.STORAGE_KEY_EXPIRE_TIME) ?? '',
    name: AdenLocalStorage.get(StorageConst.STORAGE_KEY_USER_NAME) ?? '',
    barId: AdenLocalStorage.get(StorageConst.STORAGE_KEY_BAR_ID) ?? '',
    permissions: AdenLocalStorage.get(StorageConst.STORAGE_KEY_PERMISSIONS) ?? [],
    openId: AdenLocalStorage.get(StorageConst.STORAGE_KEY_OPEN_ID) ?? '',
    userInfo: AdenLocalStorage.get(StorageConst.STORAGE_USER_INFO),
    asst: '',
    gameLifeAccount: AdenLocalStorage.get(StorageConst.STORAGE_KEY_GAME_LIFE_ACCOUNT) ?? '',
  }),
  actions: {
    loginStoreAccount(data: ILoginAccount, asst: string) {
      accountLoginRequest(data, asst).then((responseProcess: any) => {
        if (responseProcess.code !== 500) {
          this.asst = asst;
          const { access_token, name, accountId, id } = responseProcess;
          AdenLocalStorage.set(StorageConst.STORAGE_KEY_TOKEN, access_token);
          AdenLocalStorage.set(StorageConst.STORAGE_KEY_USER_NAME, name);
          AdenLocalStorage.set(StorageConst.STORAGE_KEY_ACCOUNT_ID, accountId);
          // 员工登录获取员工信息
          if (this.asst === 'asst-bar-ram-login') {
            this.fetchStaffAccountInfo(id);
          } else if (this.asst === 'asst-bar-chain-login') {
            this.fetchChainAccountInfo(id);
          } else {
            // this.fetchUserPermissions();
            this.fetchUserInfo(accountId);
          }
        } else {
          this.errorText = responseProcess.msg;
          AdenLocalStorage.clearAll();
        }
      });
    },
    // 获取员工登录时的id
    fetchUserInfo(id: number) {
      const params = {
        barId: id,
      };
      userListInfo(params)
        .then((responseProcess) => {
          this.name = responseProcess.data.name;
          this.barId = responseProcess.data.id;
          this.openId = responseProcess.data.open_id;
          this.userInfo = responseProcess.data;
          this.expireTime = responseProcess.data.expire_time;
          AdenLocalStorage.set(StorageConst.STORAGE_USER_INFO, responseProcess.data);
          AdenLocalStorage.set(
            StorageConst.STORAGE_KEY_GAME_LIFE_ACCOUNT,
            responseProcess.data.game_life_account,
          );
          AdenLocalStorage.set(StorageConst.STORAGE_KEY_BAR_ID, responseProcess.data.id);
          AdenLocalStorage.set(StorageConst.STORAGE_KEY_USER_NAME, responseProcess.data.name);
          AdenLocalStorage.set(StorageConst.STORAGE_KEY_OPEN_ID, responseProcess.data.open_id);
          AdenLocalStorage.set(
            StorageConst.STORAGE_KEY_EXPIRE_TIME,
            responseProcess.data.expire_time,
          );
        })
        .then(() => {
          this.fetchUserPermissions();
        });
    },
    fetchStaffAccountInfo(id: number) {
      getStaffId(id).then((responseProcess) => {
        if (responseProcess.code === 200) {
          if (this.asst === 'asst-bar-chain-login') {
            AdenLocalStorage.set(StorageConst.STORAGE_KEY_LOGIN_CHAIN_ID, responseProcess.data.id);
          } else {
            AdenLocalStorage.clear(StorageConst.STORAGE_KEY_LOGIN_CHAIN_ID);
          }
          this.userInfo = responseProcess.data;
          AdenLocalStorage.set(StorageConst.STORAGE_USER_INFO, responseProcess.data);
          AdenLocalStorage.set(StorageConst.STORAGE_KEY_BAR_ID, responseProcess.data.bar_id);
          AdenLocalStorage.set(StorageConst.STORAGE_KEY_USER_NAME, responseProcess.data.name);
          this.name = responseProcess.data.name;
          this.fetchUserPermissions();
        }
      });
    },
    fetchChainAccountInfo(id: number) {
      ChainList(id).then((responseProcess) => {
        if (responseProcess.code === 200 && responseProcess.data) {
          AdenLocalStorage.set(StorageConst.STORAGE_KEY_LOGIN_CHAIN_ID, responseProcess.data.id);
          AdenLocalStorage.set(StorageConst.STORAGE_KEY_BAR_ID, responseProcess.data.bar_id);
          AdenLocalStorage.set(StorageConst.STORAGE_KEY_USER_NAME, responseProcess.data.name);
          this.name = responseProcess.data.name;
          this.fetchUserPermissions();
        }
      });
    },
    // 获取用户对应的权限
    fetchUserPermissions() {
      const typeMapping: any = {
        'asst-business-system': 0, // 商户
        'asst-bar-ram-login': 2, // 员工
        'asst-bar-chain-login': 1, // 连锁
      };
      const type = typeMapping[this.asst] !== undefined ? typeMapping[this.asst] : null;
      userPermissions({ type: type }).then((responseProcess) => {
        if (responseProcess.code === 200) {
          this.permissions = responseProcess.data;
          AdenLocalStorage.set(StorageConst.STORAGE_KEY_PERMISSIONS, this.permissions);
          const redirectMapping: any = {
            'asst-business-system': { storageValue: 'business', route: '/business/main' },
            'asst-bar-ram-login': { storageValue: 'staff', route: '/staff/main' },
            'asst-bar-chain-login': { storageValue: 'chain', route: '/business/chain' },
          };
          const redirectInfo = redirectMapping[this.asst];
          if (redirectInfo && this.token === '') {
            router.push(redirectInfo.route).then();
            AdenLocalStorage.set(StorageConst.STORAGE_KEY_LOGIN_TYPE, redirectInfo.storageValue);
          }
        }
      });
    },

    clearErrorText() {
      this.errorText = '';
    },
    // 清除登录信息
    clearLoginInfo() {
      this.token = '';
      this.accountId = '';
      this.errorText = '';
      this.businessData = [];
      this.expireTime = '';
      this.name = '';
      this.barId = '';
      this.permissions = [];
      this.openId = '';
      this.asst = '';
    },
  },
});
